import { useState } from "react";
import BasicButton from "../../../ui library/components/buttons/BasicButton";
import { Typography } from "@mui/material";
import AddReferralItem from "./AddReferralItem";

export default function AddReferralForm({ submit }) {
  function generateRandomId(){
    return { id: Date.now() + Math.random() };
  }

  const [referralList, setReferralList] = useState([
    generateRandomId(),
  ]);
  
  const handleAddRow = () => {
    setReferralList((prev) => [...prev, generateRandomId()]);
  };

  const handleDeleteRow = (id) => {
    setReferralList((prev) => prev.filter((item) => item.id !== id));
  };

  const handleOnChangeRow = (id, param, value) => {
    setReferralList((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [param]: value?.id ? value.id : value } : item))
    );
  };

  return (
    <div className="w-full bg-white min-h-80 h-full flex flex-col items-center p-6 items-stretch">
      <div>
        <Typography className="text-black font-bold text-xl text-center">
          Add Referral/s
        </Typography>
      </div>
      <div className="w-full flex flex-col justify-center m-4">
        {referralList.map((item) => (
          <AddReferralItem
            key={item.id}
            onDelete={() => handleDeleteRow(item.id)}
            onChange={(param, value) =>
              handleOnChangeRow(item.id, param, value)
            }
          />
        ))}
      </div>
      <div className="w-full flex flex-row justify-end gap-4">
        <BasicButton
          disabled={false}
          text="Add Row"
          className={`w-32`}
          onClick={handleAddRow}
        />
        <BasicButton
          disabled={referralList.length === 0}
          text="Submit"
          className={`w-32 bg-green-600 hover:bg-green-700`}
          onClick={() => submit(referralList)}
        />
      </div>
    </div>
  );
}
